import { render, staticRenderFns } from "./list-items-view.vue?vue&type=template&id=6498f212&scoped=true"
import script from "./list-items-view.vue?vue&type=script&lang=js"
export * from "./list-items-view.vue?vue&type=script&lang=js"
import style0 from "./list-items-view.vue?vue&type=style&index=0&id=6498f212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6498f212",
  null
  
)

export default component.exports